<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-home </v-icon>
            Colours
            <v-spacer />
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="terminalColours"
              single-select
              class="elevation-5"
            >
              <template v-slot:item.ColourName="{ item }">
                {{ item.ColourName ? item.ColourName : "No data available" }}
              </template>
              <template v-slot:item.ColourValue="{ item }">
                {{ item.ColourValue ? item.ColourValue : "No data available" }}
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row class="mt-2 mb-2">
                    <v-col cols="12"></v-col>
                  </v-row>
                  <v-dialog v-model="dialog" max-width="800px" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small dark class="mb-2" v-bind="attrs" v-on="on">
                        <v-icon left x-small> mdi-plus </v-icon>
                        Add Colour
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h6">
                        {{ formTitle }}
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field
                              v-model="editedItem.ColourName"
                              label="Colour Name"
                              :rules="[(v) => !!v || 'Colour Name is required']"
                            ></v-text-field>

                            <v-row>
                              <v-col cols="6">
                                <label>Hexa Value</label>
                                <v-color-picker
                                  dot-size="25"
                                  mode="hexa"
                                  hide-mode-switch
                                  swatches-max-height="150"
                                  v-model="editedItem.ColourValue"
                                ></v-color-picker>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete Colour?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary"> Updating with new data.... </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,

    headers: [
      { text: "Colour Name", value: "ColourName" },
      { text: "Colour Value", value: "ColourValue" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    terminalColours: [],

    editedIndex: -1,
    editedItem: {
      ColourName: "",
      ColourValue: "#FF0000",
    },
    defaultItem: {
      ColourName: "",
      ColourValue: "#FF0000",
    },

    valid: true,
  }),

  computed: {
    ...mapState("filter", [
      "globalEventFilter",
      // 'allEvents',
      "allStallHolders",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Colour" : "Edit Colour";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.getAllProducts();
  },
  methods: {
    ...mapMutations("filter", [
      //'setGlobalEventFilter',
      // 'setAllEvents',
      "setFilterStallHolders",
    ]),
    ...mapActions("admin", ["getColours", "createColour"]),
    getAllProducts() {
      this.getColours().then((response) => {
        this.terminalColours = response;
      });
    },

    editItem(item) {
      this.editedIndex = this.terminalColours.indexOf(item);

      this.editedItem.ColourId = item.ColourId;
      this.editedItem.ColourName = item.ColourName;
      this.editedItem.ColourValue = item.ColourValue;

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.terminalColours.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.terminalColours.splice(this.editedIndex, 1);

      try {
        if (this.editedItem.ColourId) {
          let event_item = [
            {
              Type: "colour",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };
          this.createColour(submitEvent)
            .then((response) => {
              console.log("response");
              console.log(response);

              iziToast.success({
                title: "Colour",
                message: "Successfully delete record!",
                position: "topRight",
              });

              this.getAllProducts();
            })
            .catch((err) => {
              console.log("err");
              console.log(err);

              iziToast.warning({
                title: "Colour",
                message: "Fail to delete record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.log(e);
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        try {
          if (this.$refs.form.validate()) {
            let event_item = [
              {
                Type: "Colour",
                Action: this.editedIndex === -1 ? "Create" : "Edit",
                Properties: this.editedItem,
              },
            ];

            let submitEvent = {
              event_items: event_item,
            };
            console.log("submitEvent");
            console.log(submitEvent);
            this.createColour(submitEvent)
              .then((response) => {
                console.log("response");
                console.log(response);

                iziToast.success({
                  title: "Colour",
                  message: "Successfully inserted record!",
                  position: "topRight",
                });

                this.getAllProducts();
              })
              .catch((err) => {
                console.log("err");
                console.log(err);

                iziToast.warning({
                  title: "Colour",
                  message: "Fail to inserted record!",
                  position: "topRight",
                });
              });
          }
        } catch (e) {
          console.log(e);
        }
        this.close();
      }
    },
  },
};
</script>
<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
